import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ModalCloseButtonIcon } from "../libs/SVGIcons";

export const ITQModal = ({
  isOpen,
  title,
  bodyContent,
  cancelButtonText,
  cancelButtonClicked,
  buttonsModal = false,
  isCenterd = false,
  size = "lg",
}) => {
  return (
    <React.Fragment>
      <Modal
        className={"modal-" + size + " itqan-modal"}
        isOpen={isOpen}
        backdrop="static"
        centered={buttonsModal || isCenterd ? true : false}
        onClosed={() => {}}
      >
        <ModalBody>
          <div className="container">
            {!buttonsModal && (
              <>
                <div
                  className="row"
                  style={{ zIndex: "1000", position: "relative" }}
                >
                  <div className="col-12" style={{ textAlign: "right" }}>
                    {cancelButtonText && (
                      <ModalCloseButtonIcon
                        onClick={cancelButtonClicked}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-12 text-center inter inter-bold"
                    style={{
                      height: "1rem",
                      marginTop: cancelButtonText ? "-1rem" : "0rem",
                      marginBottom: "2rem",
                      fontSize: "1.125rem",
                      color: "#199B8B",
                      zIndex: "0",
                    }}
                  >
                    {title}
                  </div>
                </div>
              </>
            )}
            <div className="row">
              <div
                className="col-12"
                style={buttonsModal ? null : { marginBottom: "1rem" }}
              >
                {bodyContent}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
